import React, {Fragment, cloneElement} from "react";
import { 
    List,
    useListContext,
    sanitizeListRestProps,
    Datagrid, 
    TextField,
    Show,
    SimpleShowLayout,
    Create,
    Edit,
    SimpleForm, 
    TextInput,
    Filter,
    BulkDeleteButton,
    Toolbar,
    TopToolbar,
    CreateButton,
    SaveButton,
    DeleteButton,
    ShowButton,
    EditButton,
    CloneButton,
    required,
} from 'react-admin';
import { makeStyles } from '@material-ui/core/styles';
import RemoteSelectInput from 'components/form/RemoteSelectInput';

const useStyles = makeStyles({
    toolbar: {
        display: 'flex',
        justifyContent: 'space-between',
    },
});

const WorkerListActions = (props) => {
  const {
    className,
    exporter,
    filters,
    maxResults,
    ...rest
  } = props;
  const {
    resource,
    displayedFilters,
    filterValues,
    basePath,
    showFilter,
  } = useListContext();
  return (
    <TopToolbar className={className} {...sanitizeListRestProps(rest)}>
      {filters && cloneElement(filters, {
        resource,
        showFilter,
        displayedFilters,
        filterValues,
        context: 'button',
      })}
      <CreateButton basePath={basePath} label="新增"/>
    </TopToolbar>
  );
};

const WorkerBulkActionButtons = props => (
  <Fragment>
    <BulkDeleteButton undoable = {false} {...props} />
  </Fragment>
);

const WorkerFilter = (props) => (
  <Filter {...props}>
    <RemoteSelectInput 
      source="status_code"
      label="狀態"
      remoteurl="/code/worker-status"
      idproperty = "code"
      valueproperty = "name"
      alwaysOn
    />
  </Filter>
);

const WorkerEditToolbar = props => (
  <Toolbar {...props} classes={useStyles()}>
    <SaveButton  label="儲存"/>
    <DeleteButton label="刪除" undoable = {false} />
  </Toolbar>
);

const WorkerForm = (props) => (
  <SimpleForm {...props}>
    <TextInput 
      source="name"
      label="名稱"
      validate={required()}
      fullWidth
    />
    <TextInput 
      source="nickname"
      label="簡稱"
      validate={required()}
      fullWidth
    />
    <RemoteSelectInput 
      source="status_code"
      label="狀態"
      remoteurl="/code/worker-status"
      idproperty = "code"
      valueproperty = "name"
      validate={required()}
      fullWidth
    />
  </SimpleForm>
)

export const WorkerList = (props) => (
  <List {...props} 
    filters={<WorkerFilter />}
    actions={<WorkerListActions/>}
    bulkActionButtons={<WorkerBulkActionButtons />}
  >
    <Datagrid>
      <TextField source="name" label="名稱"/>
      <TextField source="nickname" label="簡稱"/>
      <ShowButton label="詳情"/>
      <EditButton label="編輯"/>
      <CloneButton label="複製"/>
    </Datagrid>
  </List>
);

export const WorkerShow = (props) => (
  <Show {...props}>
    <SimpleShowLayout>
      <TextField source="name" label="名稱"/>
      <TextField source="nickname" label="簡稱"/>
    </SimpleShowLayout>
  </Show>
);

export const WorkerCreate = (props) => (
  <Create {...props}>
    <WorkerForm />
  </Create>
);

export const WorkerEdit = (props) => (
  <Edit {...props} undoable = {false} >
    <WorkerForm toolbar={<WorkerEditToolbar />} />
  </Edit>
);